import React, { useContext, useEffect, useMemo, useReducer, useState } from "react";
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { sportsHandlers, sportsInitialState, sportsReducer } from "../reducers/SportsReducer";
import { _cacheNames } from "../../../../global/cnr/reducers/ServiceWorkerReducer";
import _ from 'lodash'
import { _sportsInfoTypes, useSportsInfo } from "projectSpecific/sports/useHelpers/useSportsInfo";

export const SportsContext = React.createContext()

export default function SportsProvider(props) {

  const { directReturn } = props ?? {}

  const parentContext = useContext(ParentContext)
  const { states, fns } = parentContext ?? {}
  const { appUser_state, paps_state, page_state, serviceWorker_state } = states ?? {}
  const { database_fns } = fns ?? {}

  const { cache_info } = serviceWorker_state ?? {}
  const { cache_groups } = cache_info ?? {}
  const { cache_event } = cache_groups ?? {}

  // appUserContext
  const { appUser } = appUser_state ?? {}
  const { uid } = appUser ?? {}

  // papsContext 
  const { view, pathViews } = paps_state ?? {}

  const _cacheData = cache_event && cache_event[pathViews.events]

  // pageContext 
  const { aps_page } = _.get(page_state, 'pageSettings', {});

  const { viewItems: viewItems_page } = aps_page ?? {}

  let viewItem = viewItems_page && viewItems_page[view] ? viewItems_page[view] : {}
  const { dataSource } = viewItem ?? {}
  const { dataParents, useSeasonals } = dataSource ?? {}

  // organizations/districts/sports
  // organizations/sports

  let ownerPath;

  if (pathViews) {
    if (pathViews.schools) { ownerPath = 'schools' }
    if (pathViews.districts) { ownerPath = 'districts' }
    if (pathViews.organizations) { ownerPath = 'organizations' }
  }

  const init_state = {
    pathViews,
    viewItem,
    dataParents,
    useSeasonals,
    uid,
    ownerPath,
    inverted: false,
    cssOpts: { name: 'ssc-normal' },
    _cacheData,
    database_fns
  }

  const [sports_state, sports_dispatch] = useReducer(sportsReducer, init_state, sportsInitialState)
  const sports_handlers = useMemo(
    () => sportsHandlers(sports_dispatch),
    [sports_dispatch]
  );

  const [organizationsInfo, setOrganizationsInfo] = useState()

  const { getSportInfoData } = useSportsInfo({ pathViews, sportsInfoType: _sportsInfoTypes.sport, existingData: sports_state?.organizations })

  useEffect(() => {
    // only fetch data if pathViews.organizations exists 
    getSportInfoData(_sportsInfoTypes.sport, null, setOrganizationsInfo)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [])

  useEffect(() => {
    sports_handlers.handleSportsInit()
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [])

  if (sports_state) {
    if (directReturn) {
      return { sports_handlers, sports_state }
    } else {
      return <SportsContext.Provider
        value={{ sports_state, sports_handlers, appComponent: 'sports' }}>
        {props.children}
      </SportsContext.Provider>
    }
  } else {
    return <SportsContext.Provider
      value={{}}>
      {props.children}
    </SportsContext.Provider>
  }
}